module.exports = __webpack_public_path__ + "img/20210906-1630912399980557.ce9268a6.png";